'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Select = require('calcite-react/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Menu = require('calcite-react/Menu');

var _genericUtils = require('../utils/genericUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldChooser = function FieldChooser(props) {
  var handleOnChange = function handleOnChange(field) {
    props.onChange(props.fields[field]);
  };

  var getFieldType = function getFieldType(esriFieldType) {
    var shortFieldType = (0, _genericUtils.getGenericFieldType)(esriFieldType);

    return shortFieldType.charAt(0).toUpperCase() + shortFieldType.substr(1).toLowerCase();
  };

  var getOptions = function getOptions(fields) {
    return Object.keys(fields).map(function (key) {
      var field = fields[key];
      return _react2.default.createElement(
        _Menu.MenuItem,
        {
          value: key,
          key: key,
          title: key,
          subtitle: getFieldType(field.type)
        },
        field.alias || key
      );
    });
  };

  return _react2.default.createElement(
    _Select2.default,
    {
      fullWidth: true,
      style: { whiteSpace: 'nowrap', width: '100%' },
      menuStyle: { maxHeight: '400px' },
      filterable: true,
      selectedValue: props.selectedField && props.selectedField.name,
      onChange: handleOnChange,
      placeholder: 'Select Field...'
    },
    getOptions(props.fields)
  );
};

exports.default = FieldChooser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/components/FieldChooser.js
// module id = 1472
// module chunks = 0